import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OCC_ENDPOINTS, OccProductAvailabilityResponse } from '@availability/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccAvailabilityService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadAvailability(
    productCode: string,
    unitCode: string,
    quantity: number,
    cartId?: string,
  ): Observable<OccProductAvailabilityResponse> {
    const queryParams: any = {
      quantity,
      unit: unitCode,
    };

    if (cartId) {
      queryParams.cartId = cartId;
    }

    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.productAvailability, {
      urlParams: {
        productCode,
      },
      queryParams,
    });

    return this.http.get<OccProductAvailabilityResponse>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.productAvailability),
    });
  }
}
